export interface UserAccess {
    key: UserAccessSection;
    state: UserAccessSectionState;
    reason: string;
    reasonStatus: UserAccessReasonStatus;
    disabledFrom: string;
    disabledTo: string;
}

export enum UserAccessSectionState {
    ALLOWED = 'ALLOWED',
    NOT_ALLOWED = 'NOT_ALLOWED',
    DISABLED = 'DISABLED',
    TEMPORARILY_DISABLED = 'TEMPORARILY_DISABLED',
    REQUIRED_T1 = 'REQUIRED_T1',
    REQUIRED_T2 = 'REQUIRED_T2',
    REQUIRED_T3 = 'REQUIRED_T3',
    TEMPORARILY_NOT_ALLOWED = 'TEMPORARILY_NOT_ALLOWED'
}

export enum UserAccessReasonStatus {
    MAINTENANCE = 'MAINTENANCE',
    NOT_DRAFT = 'NOT_DRAFT',
    IN_PROGRESS = 'IN_PROGRESS',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    NOT_ALLOWED_COUNTRY = 'NOT_ALLOWED_COUNTRY'
}

export enum UserAccessSection {
    WALLET_SEND = 'WALLET_SEND',
    WALLET_RECEIVE = 'WALLET_RECEIVE',
    FIAT_DEPOSIT = 'FIAT_DEPOSIT',
    FIAT_WITHDRAWAL = 'FIAT_WITHDRAWAL',
    COIN_DEPOSIT = 'COIN_DEPOSIT',
    COIN_WITHDRAWAL = 'COIN_WITHDRAWAL',
    BROKER_BUY = 'BROKER_BUY',
    BROKER_SELL = 'BROKER_SELL',
    EXCHANGE = 'EXCHANGE',
    WALLET_BALANCES = 'WALLET_BALANCES',
    EXCHANGE_BALANCES = 'EXCHANGE_BALANCES',
    BROKER_PRICE_ALERT = 'BROKER_PRICE_ALERT',
    EXCHANGE_REFERRAL_PROGRAM = 'EXCHANGE_REFERRAL_PROGRAM',
    TIER_1_VERIFICATION = 'TIER_1_VERIFICATION',
    TIER_2_VERIFICATION = 'TIER_2_VERIFICATION',
    TIER_3_VERIFICATION = 'TIER_3_VERIFICATION'
}
